export const languageFontsMap = [
  {
    lang: 'hy',
    regularFontUrl: 'NotoSansArmenian/NotoSansArmenian-Regular.ttf',
    boldFontUrl: 'NotoSansArmenian/NotoSansArmenian-Bold.ttf',
  },
  {
    lang: 'ge',
    regularFontUrl: 'NotoSansGeorgian/NotoSansGeorgian-Regular.ttf',
    boldFontUrl: 'NotoSansGeorgian/NotoSansGeorgian-Bold.ttf',
  },
  {
    lang: 'ar',
    regularFontUrl: 'NotoSansArabic/NotoSansArabic-Regular.ttf',
    boldFontUrl: 'NotoSansArabic/NotoSansArabic-Bold.ttf',
  },
];
export const commonFont = {
  // regularFontUrl: 'Selawik/Selawk-SemiLight.ttf',
  // boldFontUrl: 'Selawik/Selawk-SemiBold.ttf',
  // regularFontUrl: 'OpenSans/OpenSans-Regular.ttf',
  // boldFontUrl: 'OpenSans/OpenSans-Bold.ttf',
  // regularFontUrl: 'Inter/Inter-Regular.ttf',
  // boldFontUrl: 'Inter/Inter-Bold.ttf',
  // regularFontUrl: 'Roboto/Roboto-Regular.ttf',
  // boldFontUrl: 'Roboto/Roboto-Bold.ttf',
  regularFontUrl: 'NotoSans/NotoSans-Regular.ttf',
  boldFontUrl: 'NotoSans/NotoSans-Bold.ttf',
};
